import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { PhoneLink, QuoteButton, SectionHeading, WhatsAppButton } from "../home/CtaButtons";

export const RelatedProducts = ({ items }) => (
  <section aria-labelledby="related-title" className="section-tight border-t border-slate-200 bg-slate-50" data-testid="product-related">
    <div className="container-tight">
      <SectionHeading id="related-title" eyebrow="Bekijk ook" title="Andere producten" />
      <ul className="mt-8 grid gap-4 md:grid-cols-3">
        {items.map((r) => (
          <li key={r.href}>
            <Link to={r.href} className="card card-hover group flex h-full flex-col p-6" data-testid={`related-${r.href.slice(1)}`}>
              <span className="text-[17px] font-semibold text-ink group-hover:text-maas">{r.title}</span>
              <span className="mt-2 flex-1 text-[14.5px] leading-relaxed text-slate-600">{r.text}</span>
              <span className="mt-4 inline-flex items-center gap-1.5 text-[14px] font-semibold text-maas">Meer informatie <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" /></span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export const ProductEndCTA = ({ title, onderwerp, preselected, params }) => (
  <section aria-labelledby="end-cta-title" className="section" data-testid="product-end-cta">
    <div className="container-tight">
      <div className="relative overflow-hidden rounded-3xl bg-ink px-6 py-12 sm:px-12 sm:py-14 lg:px-16">
        <div className="hero-grid-dark absolute inset-0 opacity-60" aria-hidden="true" />
        <div className="relative grid items-center gap-8 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <h2 id="end-cta-title" className="h2 text-balance !text-white">{title}</h2>
            <p className="mt-4 text-base leading-relaxed text-slate-300 sm:text-lg">Vraag vrijblijvend een prijsindicatie aan. {preselected ? "Uw productkeuze staat in de aanvraag al voor u klaar." : "In de eerste stap kiest u het product dat bij u past."}</p>
            <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-[14px] text-slate-300">
              {["Vrijblijvend", "Foto's meesturen kan", "Persoonlijk advies"].map((t) => (
                <li key={t} className="inline-flex items-center gap-1.5"><Check className="h-4 w-4 text-[#7FD3D6]" aria-hidden="true" /> {t}</li>
              ))}
            </ul>
          </div>
          <div className="flex flex-col gap-3 sm:items-start lg:col-span-5 lg:items-end">
            <QuoteButton location="product-end-cta" onderwerp={onderwerp} params={params} className="w-full sm:w-auto" />
            <WhatsAppButton location="product-end-cta" dark className="w-full sm:w-auto" />
            <PhoneLink location="product-end-cta" dark />
          </div>
        </div>
      </div>
    </div>
  </section>
);
